import { render } from "./GavetaMinhaConta.vue?vue&type=template&id=2359c42c&scoped=true"
import script from "./GavetaMinhaConta.vue?vue&type=script&lang=js"
export * from "./GavetaMinhaConta.vue?vue&type=script&lang=js"

import "./GavetaMinhaConta.vue?vue&type=style&index=0&id=2359c42c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2359c42c"],['__file',"src/common/MenuLateral/GavetaMinhaConta.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2359c42c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2359c42c', __exports__)) {
    api.reload('2359c42c', __exports__)
  }
  
  module.hot.accept("./GavetaMinhaConta.vue?vue&type=template&id=2359c42c&scoped=true", () => {
    api.rerender('2359c42c', render)
  })

}


export default __exports__